export const today = () => new Date().toISOString().slice(0, 10);

export const currentYear = () => new Date().getFullYear();

export const money = (value) =>
  new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(Number(value || 0));

export const displayDate = (value) => {
  if (!value) return "-";
  const raw = typeof value === "string" ? value.slice(0, 10) : value;
  const date = new Date(raw);
  return Number.isNaN(date.getTime())
    ? String(value)
    : new Intl.DateTimeFormat("en-GB").format(date);
};

export const employeeName = (employee) =>
  employee ? `${employee.name || "Employee"}${employee.code ? ` (${employee.code})` : ""}` : "-";

export const humanize = (value) =>
  String(value || "-")
    .toLowerCase()
    .replaceAll("_", " ")
    .replace(/(^|\s)\S/g, (letter) => letter.toUpperCase());

export const compactParams = (params) =>
  Object.fromEntries(
    Object.entries(params || {}).filter(([, value]) => value !== null && value !== undefined && value !== "")
  );

export const envelopeData = (response) => response?.data?.data ?? response?.data ?? null;

export const paginatorRows = (paginator) => {
  if (Array.isArray(paginator)) return paginator;
  return Array.isArray(paginator?.data) ? paginator.data : [];
};

export const paginatorMeta = (paginator) => ({
  currentPage: Number(paginator?.current_page || 1),
  lastPage: Number(paginator?.last_page || 1),
  total: Number(paginator?.total || (Array.isArray(paginator) ? paginator.length : 0)),
});

export const apiError = (error, fallback = "Something went wrong.") => {
  const validation = error?.response?.data?.errors;
  if (validation && typeof validation === "object") {
    const first = Object.values(validation).flat().find(Boolean);
    if (first) return first;
  }
  return error?.response?.data?.message || error?.message || fallback;
};

export const statusColor = (status) => {
  const value = String(status || "").toUpperCase();
  if (["POSTED", "RECEIVED", "PAID", "APPROVED", "ACTIVE"].includes(value)) return "success";
  if (["PARTIAL", "SUBMITTED", "PENDING", "DRAFT"].includes(value)) return "warning";
  if (["REJECTED", "CANCELLED", "INACTIVE"].includes(value)) return "error";
  return "blue-grey";
};

export const downloadCsv = (filename, headers, rows) => {
  const escape = (value) => `"${String(value ?? "").replaceAll('"', '""')}"`;
  const csv = [headers, ...rows].map((row) => row.map(escape).join(",")).join("\n");
  const blob = new Blob(["\uFEFF", csv], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  link.click();
  URL.revokeObjectURL(url);
};
